import module from 'contabilidad/declaracionIsn/module'
import template from './template.html'
import { orderBy } from 'lodash'

export class ContabilidadDeclaracionIsnComponent {
  empresaId
  presentacionId
  periodicidadId
  fechaInicial
  fechaFinal
  empresas
  generar = false
  presentacion = [{ id: 1, descripcion: 'Prestadora de Servicios' }, { id: 2, descripcion: 'Retenedor' }, { id: 3, descripcion: 'Propia' }]
  periodicidad = [{ id: 'M', descripcion: 'Mensual' }, { id: 'B', descripcion: 'Bimestral' }, { id: 'T', descripcion: 'Trimestal' }]
  regimenFiscal = [2]
  estadoId = 25

  constructor($q, catalogoEmpresas, catalogoRegimenFiscal, CatalogoEstadosSat) {
    this.$q = $q
    this.catalogoEmpresas = catalogoEmpresas
    this.catalogoRegimenFiscal = catalogoRegimenFiscal
    this.catalogoEstadosSat = CatalogoEstadosSat
  }

  $onInit () {
    this.informacionFechas()
    this.promise = this.$q.all([
      this.catalogoEmpresas.get()
        .then(({ data }) => (this.empresas = orderBy(data.empresas.map(i => ({ empresaId: i.empresa_id, nombre: i.nombre })), ['nombre']))),
      this.catalogoRegimenFiscal.get()
        .then(({ data }) => (this.catalogoRegimenFiscal = data)),
      this.catalogoEstadosSat.get()
        .then(({ data }) => (this.estados = data))
        .then(() => (this.estados.unshift({ 'id': 999, clave: 'TODOS', descripcion: 'TODOS' }))),
    ])
  }

  informacionFechas () {
    let date = new Date()

    this.presentacionId = this.presentacionId || 3
    this.periodicidadId = this.periodicidadId || 'M'
    this.fechaInicial = this.fechaInicial || new Date(date.getFullYear(), date.getMonth(), 1)
    this.fechaFinal = this.fechaFinal || new Date(date.getFullYear(), date.getMonth() + 1, 0)
  }

  buscar () {
    this.generar = true
  }
}

module.component('contabilidadDeclaracionIsn', {
  controller: ContabilidadDeclaracionIsnComponent,
  template,
  bindings: {
    empresaId: '<',
    presentacionId: '<',
    periodicidadId: '<',
    fechaInicial: '<',
    fechaFinal: '<',
  },
})




// WEBPACK FOOTER //
// ./src/contabilidad/declaracionIsn/components/component.js